export default "/images/arrow-up-left.svg?7d84ad0460eea2890921fcb0a19ac5c9";